module.exports = __webpack_public_path__ + "img/search-icon.d328458d.svg";